import type { ReactElement } from "react";
import { Layout } from "react-admin";
import type { LayoutProps } from "react-admin";
import LayoutAppBar from "./LayoutAppBar";
import LayoutMenu from "./LayoutMenu";
import RetirementGate from "./RetirementGate";

/**
 * Override RA's `minWidth: fit-content` on the layout root so wide tables
 * (e.g. staff attendance) scroll inside the content pane instead of growing the window.
 */
const layoutSx = {
  minWidth: 0,
  "& .RaLayout-content": {
    minWidth: 0,
    maxWidth: "100%",
  },
  "& .RaLayout-contentWithSidebar": {
    minWidth: 0,
  },
} as const;

const AdminLayout = (props: LayoutProps): ReactElement => {
  const { sx, ...rest } = props;
  return (
    <>
      <RetirementGate />
      <Layout
        {...rest}
        menu={LayoutMenu}
        appBar={LayoutAppBar}
        sx={[layoutSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
      />
    </>
  );
};

export default AdminLayout;
